import { getCleanUrl } from '@theme/js/utils/url.util';

export const getMenuItemByURL = (items, itemFriendlyURL) => {
    for (const item of items) {
        if (getCleanUrl(item.friendlyURL) === itemFriendlyURL) { /* Lugano changes */
            return item;
        } else if (item.children?.length) {
            const found = getMenuItemByURL(item.children, itemFriendlyURL);

            if (found) {
                return found;
            }
        }
    }
};
